import React, { useState, useEffect } from 'react';
import {
  Typography,
  Grid,
  Box,
  Card,
  Button,
  Select,
  Input,
  MenuItem,
  IconButton,
} from '@material-ui/core';
import { apiGet, pageFromLegacy } from '../../../api/client';
import { legacyOfferListFromApi } from '../../../api/requestsAdapter';
import DirectRequestsTable from './DirectRequestsTable';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import CircularProgress from '@material-ui/core/CircularProgress';
import CircularProgressIndicator from '../../../components/CircularProgressIndicator';

export default function DirectRequests() {
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalElements, setTotalElements] = useState();
  const [refresh, setRefresh] = useState(true);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    setData([]);
    apiGet('/offers', {
      status: 'SPAwaited',
      pageSize,
      page: pageFromLegacy(pageNumber),
    })
      .then(({ data }) => {
        if (data.total === 0) setCreate(true);
        setData((data.data || []).map(legacyOfferListFromApi));
        setTotalElements(data.total);
        setLoad(false);
      })
      .catch((err) => {
        alert(`ERR: ${err}`);
        console.log(err);
      });
  }, [pageSize, pageNumber, refresh]);

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      key={data.length}
    >
      <CircularProgressIndicator open={load} />
      {data.length > 0 ? (
        <Typography align="center" style={{ marginTop: 20, fontSize: 40 }}>
          Direct Requests
        </Typography>
      ) : (
        create && (
          <Grid
            container
            justify="center"
            alignItems="center"
            direction="column"
          >
            <Typography variant="h3">{`You don't have any direct requests at the moment!`}</Typography>
          </Grid>
        )
      )}
      {data.length > 0 && (
        <DirectRequestsTable
          content={data}
          refresh={() => setRefresh(!refresh)}
          load={() => setLoad(!load)}
        />
      )}

      {data.length > 0 && (
        <Grid container directoin="row" justify="flex-end" alignItems="center">
          <Typography>rows per page&nbsp;&nbsp;</Typography>
          <Select
            name="RowsPerPage"
            id="rowsperpage"
            input={<Input disableUnderline />}
            value={pageSize}
            onChange={(event) => {
              setPageSize(event.target.value);
              setPageNumber(0);
            }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem
              value={10}
              disabled={(pageNumber + 1) * 5 >= totalElements}
            >
              10
            </MenuItem>
            <MenuItem
              value={15}
              disabled={(pageNumber + 1) * 10 >= totalElements}
            >
              15
            </MenuItem>
            <MenuItem
              value={20}
              disabled={(pageNumber + 1) * 15 >= totalElements}
            >
              20
            </MenuItem>
          </Select>
          <IconButton
            disabled={pageNumber === 0}
            onClick={() => setPageNumber(pageNumber - 1)}
          >
            <NavigateBeforeIcon />
          </IconButton>
          <IconButton
            disabled={(pageNumber + 1) * pageSize >= totalElements}
            onClick={() => setPageNumber(pageNumber + 1)}
          >
            <NavigateNextIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
}
